import React, { useRef } from "react";

import Icon from "src/icons";
import Tooltip from "src/components/Tooltip";

import type { Nullable } from "src/ts-types";

import {
  ViewAuditTrail as StyledViewAuditTrail,
  ViewUpdatesButton,
  ViewUpdatesLabel,
  ViewUpdatesHr,
} from "./styles";

interface Props {
  count: number;
  toggleExpansion: (element: Nullable<HTMLDivElement>) => void;
  expanded: boolean;
  sticky: boolean;
}

const ViewAuditTrail = ({
  count,
  toggleExpansion,
  expanded,
  sticky,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  return (
    <StyledViewAuditTrail
      role="button"
      onClick={() => toggleExpansion(containerRef.current)}
      expanded={expanded}
      sticky={sticky}
      tabIndex={0}
      ref={containerRef}
    >
      <ViewUpdatesHr />
      <Tooltip
        title={
          expanded
            ? "Click here to collapse updates"
            : "Click here to expand updates"
        }
      >
        <ViewUpdatesButton>
          <Icon type={expanded ? "caretDoubleUp" : "caretDoubleDown"} />
          <ViewUpdatesLabel>
            {expanded ? "Viewing" : "View"} {count}{" "}
            {count === 1 ? "update" : "updates"}
          </ViewUpdatesLabel>
        </ViewUpdatesButton>
      </Tooltip>
      <ViewUpdatesHr />
    </StyledViewAuditTrail>
  );
};

export default ViewAuditTrail;
